/** 是否具备 B 端后台访问能力（租户管理员 / 受邀员工 / 平台超管） */
export function canAccessBackend(
  user?: {
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
    isStaff?: boolean;
  } | null
): boolean {
  return user?.isAdmin === true || user?.isSuperAdmin === true || user?.isStaff === true;
}
